module.exports = __webpack_public_path__ + "img/DSC_5158.f22115df.jpg";